import React from "react";
import {
  WEEKEND_ROUND_BUTTONS,
  WEEKEND_ROUND_GROUPS,
  groupRoundButtons,
} from "../../config/admissionRound";
import RoundImageRows from "./RoundImageRows";

import wrob1 from "../../assets/2027/weekend/wrob1.png";
import wrob2 from "../../assets/2027/weekend/wrob2.png";
import wrob3 from "../../assets/2027/weekend/wrob2.png";

const IMAGES = { wrob1, wrob2, wrob3 };

/** ปริญญาตรี ภาค กศ.บป. (เสาร์-อาทิตย์) — /Register/2 */
function WeekendRounds({ rounds, selectedRobId, onSelect }) {
  const groups = groupRoundButtons(
    WEEKEND_ROUND_BUTTONS,
    WEEKEND_ROUND_GROUPS,
    IMAGES
  );

  // ไม่มีรอบจากหลังบ้าน = ยังไม่เปิดระบบ ไม่ต้องโชว์ปุ่มค้างไว้
  if (!rounds || rounds.length === 0 || groups.length === 0) {
    return <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>;
  }

  return (
    <RoundImageRows
      groups={groups}
      selectedRobId={selectedRobId}
      onSelect={onSelect}
    />
  );
}

export default WeekendRounds;
